import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { useClient } from "../../ClientContext";
import { PortalClientError } from "../../types";
import { JsonApiResponse } from "../types";
import { UseRewardsParams, Reward } from "./types";

const useRewards = <TData extends {} = JsonApiResponse<Reward[]>>(
  params: UseRewardsParams,
  queryOptions?: UseQueryOptions<
    JsonApiResponse<Reward[]>,
    PortalClientError,
    TData
  >
) => {
  const client = useClient();

  return useQuery<JsonApiResponse<Reward[]>, PortalClientError, TData>(
    ["rewards", params],
    () =>
      client.get("/rewards", {
        params,
      }),
    {
      refetchOnWindowFocus: false,
      ...queryOptions,
    }
  );
};

export default useRewards;
